//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      data: this.$data
    };
  },
  methods: {
    $ready: function $ready() {
      this.$dispatchEvent("forms/addSubmit", this.$data);
    }
  }
};